import './HowToSyncBodyAccountDetails.scss'
import { Trans, useTranslation } from 'react-i18next';
import AcVideoPlayer from '../AcVideoPlayer/AcVideoPlayer';
import AcHorizontalSeparator from '../AcHorizontalSeparator/AcHorizontalSeparator';
import { useHowToSyncContext } from '../../providers/HowToSyncProvider';

export default function HowToSyncBodyAccountDetails() {
    const { t } = useTranslation();
    const syncGoogleCalSynIn = t('settingsPage.howToSync.jumpSection.syncGoogleCalSynIn');
    const syncGoogleCalContinue = t('settingsPage.howToSync.jumpSection.syncGoogleCalContinue');
    const syncGoogleCalNext = t('settingsPage.howToSync.jumpSection.syncGoogleCalNext');
    const syncGoogleCalDone = t('settingsPage.howToSync.jumpSection.syncGoogleCalDone');
    const syncGoogleCalReEnter = t('settingsPage.howToSync.jumpSection.syncGoogleCalReEnter');
    const syncGoogleCalOptionally = t('settingsPage.howToSync.jumpSection.syncGoogleCalOptionally');
    const syncGoogleCalAddAccount = t('settingsPage.howToSync.jumpSection.syncGoogleCalAddAccount');
    const syncGoogleCalSettings = t('settingsPage.howToSync.jumpSection.syncGoogleCalSettings');
    // const syncAppleCalSignIn = t('settingsPage.howToSync.jumpSection.syncAppleCalSignIn');
    // const syncAppleCalAppSpec = t('settingsPage.howToSync.jumpSection.syncAppleCalAppSpec');
    // const syncAppleCalPlsEns = t('settingsPage.howToSync.jumpSection.syncAppleCalPlsEns');
    // const syncAppleCalContinue = t('settingsPage.howToSync.jumpSection.syncAppleCalContinue');
    // const syncAppleCalAppleId = t('settingsPage.howToSync.jumpSection.syncAppleCalAppleId');
    // const syncAppleCalGenApp = t('settingsPage.howToSync.jumpSection.syncAppleCalGenApp');
    // const syncAppleCalMyAccess = t('settingsPage.howToSync.jumpSection.syncAppleCalMyAccess');
    // const syncAppleCalCreate = t('settingsPage.howToSync.jumpSection.syncAppleCalCreate');
    // const syncAppleCalAuth = t('settingsPage.howToSync.jumpSection.syncAppleCalAuth');
    // const syncAppleCalOptionally = t('settingsPage.howToSync.jumpSection.syncAppleCalOptionally');
    // const syncAppleCalAddAccount = t('settingsPage.howToSync.jumpSection.syncAppleCalAddAccount');
    // const syncAppleCalSettings = t('settingsPage.howToSync.jumpSection.syncAppleCalSettings');
    const syncOutlookCalFlySch = t('settingsPage.howToSync.jumpSection.syncOutlookCalFlySch');
    const syncOutlookCalSettings = t('settingsPage.howToSync.jumpSection.syncOutlookCalSettings');
    const syncOutlookCalOutIcon = t('settingsPage.howToSync.jumpSection.syncOutlookCalOutIcon');
    const syncOutlookCalUnd = t('settingsPage.howToSync.jumpSection.syncOutlookCalUnd');
    const syncOutlookCalConsent = t('settingsPage.howToSync.jumpSection.syncOutlookCalConsent');
    const syncOutlookCalVerf = t('settingsPage.howToSync.jumpSection.syncOutlookCalVerf');
    const syncOutlookCalSucc = t('settingsPage.howToSync.jumpSection.syncOutlookCalSucc');
    const howToSyncContext = useHowToSyncContext();

    const openSettings = () => {
        const win : Window | null = window.open("settings", "_blank");
        if(win) win.focus();
    }

    // const openAppSpecPage = () => {
    //     const win : Window | null = window.open("https://support.apple.com/en-us/HT204397", "_blank");
    //     if(win) win.focus();
    // }

    return (
        <div className='hts-body-account__container'>
            <div className='hts-body-account__jts'>
                {/* jump to section */}
                <div className='hts-body-account__jts-section'>
                    <p className='hts-body-account__jts-section--title'>{t('settingsPage.howToSync.jumpSection.jumpTo')}</p>
                    <p className='hts-body-account__jts-section--details'>
                        <a href='#hts-body-account__google'>{t('settingsPage.howToSync.jumpSection.google')}</a>
                        {/* <a href='#hts-body-account__apple'>{t('settingsPage.howToSync.jumpSection.apple')}</a> */}
                        <a href='#hts-body-account__outlook'>{t('settingsPage.howToSync.jumpSection.outlook')}</a>
                    </p>
                </div>
                {/* enable this once Faq Sync Page is ready */}
                {/* <div className='hts-body-account__jts-section hts-body-account__jts-section--border'>
                    <p className='hts-body-account__jts-section--title'>{t('settingsPage.howToSync.jumpSection.goToPage')}</p>
                    <p className='hts-body-account__jts-section--details'>
                        <span>{t('settingsPage.howToSync.jumpSection.faq')}</span>
                    </p>
                </div> */}
            </div>
            <div className='hts-body-account__generic' id='hts-body-account__google'>
                {/* sync to google cal */}
                <p className='hts-body-account__generic-title'>{t('settingsPage.howToSync.jumpSection.google')}</p>
                <div className='hts-body-account__generic-steps'>
                    <p className='hts-body-account__generic-step'>
                        <span>1. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncGoogleCal1' >
                                <span style={{fontWeight:600}}>{{ syncGoogleCalSynIn }}</span>
                                <span style={{fontWeight:600}}>{{ syncGoogleCalContinue }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>2. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncGoogleCal2'></Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>3. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncGoogleCal3'>
                                <span style={{fontWeight:600}} >{{ syncGoogleCalNext }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>4. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncGoogleCal4'></Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>5. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncGoogleCal5'>
                                <span style={{fontWeight:600}}>{{ syncGoogleCalDone }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>6. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncGoogleCal6'>
                                <span style={{fontWeight:600}}>{{ syncGoogleCalReEnter }}</span>
                                <span style={{fontWeight:600,fontStyle:'italic'}}>{{ syncGoogleCalOptionally }}</span>
                                <span style={{fontWeight:600}}>{{ syncGoogleCalAddAccount }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>7. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncGoogleCal7'>
                                <span style={{fontWeight:600,color:'#005078',cursor:'pointer'}} onClick={()=>openSettings()}>{{ syncGoogleCalSettings }}</span>
                            </Trans>
                        </span>
                    </p>
                </div>
                <AcVideoPlayer videoUrl={howToSyncContext?.howToSyncVideos["STC_Google.mp4"]} videoThumbnail="" />
            </div>
            {/* <AcHorizontalSeparator /> */}
            {/*
            <div className='hts-body-account__generic' id='hts-body-account__apple'>               
                <p className='hts-body-account__generic-title'>{t('settingsPage.howToSync.jumpSection.apple')}</p>
                <div className='hts-body-account__generic-steps'>
                    <p className='hts-body-account__generic-step'>
                        <span>&nbsp;&nbsp;1. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal1' >
                                <span style={{fontWeight:600}}>{{ syncAppleCalSignIn }}</span>
                                <span style={{fontWeight:600}}>{{ syncAppleCalAppSpec }}</span>
                                <span style={{fontWeight:600}}>{{ syncAppleCalPlsEns }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>&nbsp;&nbsp;2. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal2' >
                                <span style={{fontWeight:600}}>{{ syncAppleCalContinue }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>&nbsp;&nbsp;3. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal3' >
                                <span style={{fontWeight:600}}>{{ syncAppleCalAppleId }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>&nbsp;&nbsp;4. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal4' >                                
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>&nbsp;&nbsp;5. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal5' >                                
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>&nbsp;&nbsp;6. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal6' >
                                <span style={{fontWeight:600,color:'#005078',cursor:'pointer'}} onClick={()=>openAppSpecPage()}>{{ syncAppleCalAppSpec }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>&nbsp;&nbsp;7. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal7' >
                                <span style={{fontWeight:600}}>{{ syncAppleCalGenApp }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>&nbsp;&nbsp;8. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal8' >
                                <span style={{fontWeight:600,fontStyle:'italic'}}>{{ syncAppleCalMyAccess }}</span>
                                <span style={{fontWeight:600}}>{{ syncAppleCalCreate }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>&nbsp;&nbsp;9. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal9' >
                                <span style={{fontWeight:600}}>{{ syncAppleCalAuth }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>10. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal10' >
                                <span style={{fontWeight:600}}>{{ syncAppleCalOptionally }}</span>
                                <span style={{fontWeight:600}}>{{ syncAppleCalAddAccount }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>11. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncAppleCal11' >
                                <span style={{fontWeight:600,color:'#005078',cursor:'pointer'}} onClick={()=>openSettings()}>{{ syncAppleCalSettings }}</span>
                            </Trans>
                        </span>
                    </p>
                </div>
                <AcVideoPlayer videoUrl={howToSyncContext?.howToSyncVideos["STC_iOS.mp4"]} videoThumbnail="" />
            </div> 
            */}
            <AcHorizontalSeparator />
            <div className='hts-body-account__generic' id='hts-body-account__outlook'>
                {/* sync to outlook cal */}
                <p className='hts-body-account__generic-title'>{t('settingsPage.howToSync.jumpSection.outlook')}</p>
                <div className='hts-body-account__generic-steps'>
                    <p className='hts-body-account__generic-step'>
                        <span>1. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncOutlookCal1' >
                                <span style={{fontWeight:600}}>{{ syncOutlookCalFlySch }}</span>
                                <span style={{fontWeight:600}}>{{ syncOutlookCalSettings }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>2. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncOutlookCal2'>
                                <span style={{fontWeight:600}}>{{ syncOutlookCalOutIcon }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>3. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncOutlookCal3'>
                                <span style={{fontWeight:600}}>{{ syncOutlookCalUnd }}</span>
                                <span style={{fontWeight:600}}>{{ syncOutlookCalConsent }}</span>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>4. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncOutlookCal4'>
                            </Trans>
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>5. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncOutlookCal5'>
                                <span style={{fontWeight:600}}>{{ syncOutlookCalVerf }}</span>
                                <span style={{fontWeight:600}}>{{ syncOutlookCalSucc }}</span>
                            </Trans>                            
                        </span>
                    </p>
                    <p className='hts-body-account__generic-step'>
                        <span>6. </span>
                        <span>
                            <Trans i18nKey='settingsPage.howToSync.jumpSection.syncOutlookCal6'>
                            </Trans>
                        </span>
                    </p>
                </div>
                <AcVideoPlayer videoUrl={howToSyncContext?.howToSyncVideos["STC_Outlook.mp4"]} videoThumbnail="" />
            </div>
        </div>
    )
}
